import React from 'react';
import InfoTooltip from './InfoTooltip';
import { DEA_SCHEDULES_URL } from '../utils/deaScheduleLabels';

export interface DeaScheduleHeaderTooltipProps {
  /** Forwarded to InfoTooltip — override for a call site nested above InfoTooltip's own default. */
  zIndex?: number;
}

/**
 * Field-level tooltip for the "DEA Schedule" label — outlines what each
 * schedule value represents and links back to the source (2026-09-23
 * follow-up feedback: a bare "CII"/"CIV" carried no explanation anywhere
 * this field is shown). Mirrors TeCodeHeaderTooltip.tsx/
 * ApplTypeHeaderTooltip.tsx's pattern.
 */
const DeaScheduleHeaderTooltip: React.FC<DeaScheduleHeaderTooltipProps> = ({
  zIndex,
}) => (
  <InfoTooltip
    ariaLabel="About DEA Schedule"
    zIndex={zIndex}
    interactive
    text={
      <span>
        CI = Schedule I (no accepted medical use, high abuse potential)
        <br />
        CII = Schedule II (high abuse potential)
        <br />
        CIII = Schedule III (moderate abuse potential)
        <br />
        CIV = Schedule IV (low abuse potential)
        <br />
        CV = Schedule V (lowest abuse potential)
        <br />
        Source:{' '}
        <a
          href={DEA_SCHEDULES_URL}
          target="_blank"
          rel="noopener"
          style={{ color: 'inherit', textDecoration: 'underline' }}>
          DEA Diversion Control Division
        </a>
      </span>
    }
  />
);

export default DeaScheduleHeaderTooltip;
